import React, { useEffect, useState } from "react";
import Button from "../../../components/Buttons/Button";
import DataTable from "../../../components/DataTable/DataTable";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import BrandModel from "../../../models/BrandModel";
import BrandReferenceModel from "../../../models/BrandReferenceModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface BrandReferencesExportModel {
    brandId: number
    brandReferences: BrandReferenceModel[]
}

interface IProps extends PopupProps {
    brand: BrandModel
}

const ExportBrandPopup: React.FC<IProps> = ({ show, onHide, brand }) => {
    const { handleResult, handleException } = useNotifications();
    const [data, setData] = useState<BrandReferencesExportModel>();

    useEffect(() => {
        getData()
    }, [brand]);

    function getData() {
        if (brand) {
            DataService.get<BrandReferenceModel[]>('api/v1/BrandReferences/ByBrand/' + brand.id)
                .then(response => {
                    setData({
                        brandId: brand.id,
                        brandReferences: response
                    })
                })
        }
    }

    function submit() {
        if (data) {
            data.brandReferences = data.brandReferences.filter(x => x['_checkbox_export'] === true)
            DataService
                .post<Result>(`api/v1/BrandReferences/export`, data)
                .then(response => {
                    handleResult(response);
                    if (response.isSuccesful === true)
                        onHide();
                    else
                        getData();
                })
                .catch(e => handleException(e));
        }
    }

    function selectAllRows(selectedRows: any[]) {
        if (data) {
            if (selectedRows.length != data.brandReferences.length)
                data.brandReferences.forEach(r => r['_checkbox_export'] = true)
            else
                data.brandReferences.forEach(r => r['_checkbox_export'] = false)

            setData(x => ({...data}))
        }
    }

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Export brand'} >
            <Popup.Body>
                {data && (
                    <DataTable
                        name='dtBrandExport'
                        colInfos={[
                            { key: true, dataProp: 'id', visible: false },
                            { checkboxButton: { icon: 'fa-check', color: 'green', text: 'export', onClick: (selectedRows) => { selectAllRows(selectedRows); } } },
                            { title: 'External System', dataProp: 'externalSystemName' },
                            { title: 'Reference code', dataProp: 'referenceCode' },
                            { title: 'Ready on', dataProp: 'readyForExportOn', dataType: 'datetime' },
                            { title: 'Exported on', dataProp: 'exportedOn', dataType: 'datetime' },
                        ]}
                        tableData={data.brandReferences}
                    />
                )}
            </Popup.Body>
            <Popup.Footer>
                <Button text="Export" type='button' onClick={submit} />
            </Popup.Footer>
        </Popup>
    );
}
export default ExportBrandPopup;